import getWithToken from './base/get-with-token'

const getMapDataWasteWater = getWithToken('/map-data/waste-water')

export default getMapDataWasteWater